// App.js (Complete with both Home and Calculator fixes)
import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Helmet } from "react-helmet";
import "./App.css";
import NavBar from './components/NavBar';
import Home from './components/Home';
import Footer from './components/Footer';
import WaldoAd from './components/AdComponent';

// Import routes configuration
import { calculatorRoutes } from './routes';

// Loading spinner component
const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
    <p>Loading calculator...</p>
  </div>
);

// Static Home Route with SEO meta tags
const HomeRoute = () => (
  <div key="home"> {/* ⭐ KEY ADDED HERE */}
    <Helmet>
      <title>Best Free Math Calculators Online | Tools.D-TechStudios.com</title>
      <meta 
        name="description" 
        content="Use free online math calculators for addition, subtraction, division, multiplication, percentages, rounding and more. Simple, fast and accurate tools." 
      />
      <meta 
        name="keywords" 
        content="math calculators, online calculators, basic math tools, free calculators, Tools.D-TechStudios.com" 
      />
    </Helmet>
    <Home />
    <WaldoAd />
  </div>
);

// Create lazy-loaded component wrapper for math tools
const CalculatorRoute = ({ componentName, folder, title, description, keywords }) => {
  const CalculatorComponent = lazy(() => import(`./components/Pages/${folder}/${componentName}`));
  
  return (
    <div key={componentName}> {/* ⭐ KEY ADDED HERE */}
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
      </Helmet>
      <Suspense fallback={<LoadingSpinner />}>
        <CalculatorComponent />
      </Suspense>
      <WaldoAd />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <NavBar />
      <div className="pages">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            {/* Static Home Route */}
            <Route path="/" element={<HomeRoute />} />
            
            {/* Dynamic Calculator Routes */}
            {calculatorRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  <CalculatorRoute
                    componentName={route.component}
                    folder={route.folder}
                    title={route.title}
                    description={route.description}
                    keywords={route.keywords}
                  />
                }
              />
            ))}
          </Routes>
        </Suspense>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;